var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Supplier Return Handovers"}},[_c('div',{staticClass:"flex vx-input-group"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Handover"}},[_c('tab',{attrs:{"tab":"handover"}})],1),_c('vs-tab',{attrs:{"label":"Completed"}},[_c('tab',{attrs:{"tab":"completed"}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }